import ColorClass from "types/enums/ColorClass";
import FontClass from "types/enums/FontClass";
import joinClasses from "utils/joinClasses";
import styles from "css/text/HeaderText.module.css";

export type Props = {
  children:
    | string
    | JSX.Element
    | Array<JSX.Element | string | number>
    | number;
  className?: string;
  colorClass?: ColorClass;
  fontClass: FontClass;
  textAlign?: "center" | "left" | "right";
  textTransform?: "none" | "uppercase";
};

export default function HeaderText({
  children,
  className,
  colorClass,
  fontClass,
  textAlign,
  textTransform,
}: Props): JSX.Element {
  const classNameJoined = joinClasses(
    fontClass,
    styles.header,
    className,
    colorClass
  );

  const style = {
    ...(textAlign != null ? { textAlign } : {}),
    ...(textTransform != null ? { textTransform } : {}),
  };

  switch (fontClass) {
    case FontClass.Header1:
      return (
        <h1 className={classNameJoined} style={style}>
          {children}
        </h1>
      );
    case FontClass.Header2:
      return (
        <h2 className={classNameJoined} style={style}>
          {children}
        </h2>
      );
    case FontClass.Header3:
      return (
        <h3 className={classNameJoined} style={style}>
          {children}
        </h3>
      );
    default:
      throw new Error(`Unexpected fontClass of ${fontClass}`);
  }
}
